import { sleep } from '@polaris/core/utils'
import { useMutation } from '@tanstack/react-query'
import { useState } from 'react'

export function useCopyToClipboardWithDelay(delayMs = 3000) {
  const [isHolding, setIsHolding] = useState(false)
  const res = useMutation({
    mutationFn: async (content: string) =>
      await navigator.clipboard.writeText(content),
    onSuccess: async () => {
      setIsHolding(true)
      await sleep(delayMs)
      setIsHolding(false)
    },
  })

  return { isHolding, ...res }
}
